import React from 'react';
export default function CourseOutline() {
  return (
    <div className="section-container">
    <section id="overview" data-aos="fade-up">
      <h2>Course Overview</h2>
      <p>
            This 3-month certification course covers five major domains in emerging technologies:
            Artificial Intelligence & Tools, Machine Learning & Deep Learning, Internet of Things,
            Cyber Security, and Quantum Computing. The course includes 120 sessions with 10 sessions
            per week and focuses on both theoretical knowledge and hands-on experience.
          </p>
          <p><strong>Eligibility:</strong> Open to all graduates (B.Tech, B.A, B.Com, etc.)</p>
          <h3>Weekly Subject Plan</h3>
          <ul>
            <li><strong>Week 1–2:</strong> Artificial Intelligence & Tools</li>
            <li><strong>Week 3–4:</strong> Machine Learning & Deep Learning</li>
            <li><strong>Week 5–6:</strong> Internet of Things (IoT)</li>
            <li><strong>Week 7–8:</strong> Cyber Security</li>
            <li><strong>Week 9–10:</strong> Quantum Computing</li>
            <li><strong>Week 11–12:</strong> Capstone Project & Final Assessment</li>
          </ul>
    </section>
    </div>
  );
}
